import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import ReviewData from "./Review-data";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Select,
} from "reactstrap"

class EmailHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
     
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Contact Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid>
             <Breadcrumbs
              title={this.props.t("Contact")}
              breadcrumbItem={this.props.t("Reviews History")}
            />
           
       	
           
            <Row>
            <Col lg="12">
              
            <Card>
        <CardBody>
        <CardTitle className="mb-4 float-start">
           
        
         </CardTitle>
       
       <div className="clearfix"></div>
          <div className="table-responsive">
            <table className="table align-middle table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  
                  <th className="align-middle">Name</th>
                  
                  <th className="align-middle">Email</th>

                  <th className="align-middle">Status</th>

                 
                </tr>
              </thead>
             <tbody>
                <tr>
                    <td>Elise Michelle</td>
                    <td>elise@gmail.com</td>
                    <td>Opened</td>
                   
                </tr>

             </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
            </Col>
          </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
EmailHistory.propTypes = {
  t: PropTypes.any

}
export default connect()(withTranslation()(EmailHistory))
